import 'es5-shim'
import 'es6-shim'
import WebpackerReact from 'webpacker-react'

// Import components
import Exception from '../components/exception'

// Repack components
WebpackerReact.setup({ Exception })



// WEBPACK FOOTER //
// ./app/javascript/packs/exception.js